export default "__VITE_ASSET__DslCoVyc__"